import {
    KatButton,
    KatInput
} from "@amzn/katal-react";
import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import Review from "src/app/component/review/Review";
import {StringUtil} from "src/app/util/StringUtil";
import ReviewDecisionStore from "src/app/store/ReviewDecisionStore";
import reviewEventBus from "src/app/eventbus/ReviewEventBus";
import {ReviewEvent} from "src/app/constant/Enums";

interface RouteParams {
    reviewId: string;
}

const REVIEW_DETAIL_PAGE_URL = '/review';
const SLASH = '/';
const ENTER_KEY = 'Enter';

const ReviewDetail = () => {
    const history = useHistory();

    const reviewIdRef = useRef<any>(null);

    const {reviewId} = useParams<RouteParams>();

    const [currentReviewId, setCurrentReviewId] = useState(reviewId);

    let unListen: () => void;

    useEffect(() => {
        reviewEventBus.on(ReviewEvent.CLOSE_REVIEW, handleReviewClose);
        unListen = history.listen(listener);
        return () => {
            if (unListen) {
                unListen();
            }
            reviewEventBus.removeListener(ReviewEvent.CLOSE_REVIEW, handleReviewClose);
        };
    }, [history]);

    const listener = () => {
        const location = window.location.pathname;
        const pathParts = location.split(SLASH);
        const pathReviewId = pathParts[2];
        if (pathReviewId == undefined) {
            setVisible(false);
        } else {
            setVisible(true);
        }
    };

    const handleReviewClose = (isReviewDone: any) => {
        if (isReviewDone) {
            closeReview();
        }
    };

    const [visible, setVisible] = useState(() => {
        return !StringUtil.isNullOrEmpty(reviewId);
    });

    const onKeyup = (e: any) => {
        const key = e.key;
        if (ENTER_KEY === key) {
            openReview();
        }
    }

    function openReview() {
        const reviewId = reviewIdRef.current.value;
        if (StringUtil.isNullOrEmpty(reviewId)) {
            alert("please input the review id!");
        } else {
            setCurrentReviewId(reviewId.trim());
            const url = REVIEW_DETAIL_PAGE_URL + SLASH + reviewId.trim();
            history.push(url);
            setVisible(true);
        }
    }

    const closeReview = () => {
        ReviewDecisionStore.resetValue();
        setVisible(false);
        history.push(REVIEW_DETAIL_PAGE_URL);
    }

    return (
        <div>
            {!visible &&
                <div id='query-box' className='search-box default-margin'>
                    <div className='inline-display default-margin'>
                        <KatInput label='Case ID' className='text-input' value={currentReviewId}
                                  ref={reviewIdRef}
                                  onKeyup={e => onKeyup(e)} data-testid='review-id-input'
                        ></KatInput>
                        <KatButton onClick={openReview} className='stay-bottom'
                                   data-testid='submit-btn'>View</KatButton>
                    </div>
                </div>
            }
            {visible &&
                <Review reviewId={currentReviewId} data-testid='review'/>
            }
        </div>
    );
}

export default ReviewDetail;